import { mutatorAction } from "satcheljs";
import { SchedulesViewStateStore } from "sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";

/**
 * Set the grouped/ungrouped state of the Schedules page.
 */
export default mutatorAction("SET_GROUPED_VIEW",
    function setGroupedView(viewState: SchedulesViewStateStore | IPreviewSchedulePageStore, isViewGrouped: boolean) {
        viewState.isViewGrouped = isViewGrouped;
    }
);